import gql from 'graphql-tag';
import ordersWrapperFragment from './ordersWrapperFragment.gql';

export default gql`
  query ($wrapper_id: ID, $legacy_order_id: ID) {
    wrapper(wrapper_id: $wrapper_id, legacy_order_id: $legacy_order_id) {
      ...ordersWrapperFragment
    }
  }
  ${ordersWrapperFragment}
`;



// WEBPACK FOOTER //
// ./app/containers/LegacyCartPage/graphql/ordersWrapperQuery.gql.js